import * as agreementConstants from 'agreement/constants';
import type { ChartType } from './types';

export const filterableStates: { [key: number]: string } = {
  [agreementConstants.STATE_PENDING]: 'pending',
  [agreementConstants.STATE_OVERDUE]: 'overdue',
  [agreementConstants.STATE_SIGNED]: 'signed',
  [agreementConstants.STATE_DECLINED]: 'declined',
};

export const filterableLifecycles: { [key: number]: string } = {
  [agreementConstants.LIFECYCLE_AWAITING]: 'awaiting',
  [agreementConstants.LIFECYCLE_ACTIVE]: 'active',
  [agreementConstants.LIFECYCLE_ENDED]: 'ended',
  [agreementConstants.LIFECYCLE_NOT_SET]: 'notset',
};

export const AI_INSIGHTS_QUERY_AGREEMENTS = 'aiInsights';

type Chart = {
  type: 'vertical' | 'bar' | 'pie';
  chartName: string;
};

export const chartTypes: Record<ChartType, Chart> = {
  all: {
    type: 'pie',
    chartName: 'total issues',
  },
  Confidentiality: {
    type: 'pie',
    chartName: 'confidentiality',
  },
  PriceAdjustment: {
    type: 'pie',
    chartName: 'price adjustment',
  },
  LimitationOfLiability: {
    type: 'pie',
    chartName: 'limitation of liability',
  },
  AutomaticRenewal: {
    type: 'pie',
    chartName: 'automatic renewal',
  },
  LiquidatedDamages: {
    type: 'pie',
    chartName: 'liquidated damages',
  },
  GoverningLaw: {
    type: 'vertical',
    chartName: 'governing law',
  },
  Termination: {
    type: 'pie',
    chartName: 'termination',
  },
  PaymentTerm: {
    type: 'vertical',
    chartName: 'payment terms',
  },
  NoticePeriod: {
    type: 'bar',
    chartName: 'notice period',
  },
  ForceMajeure: {
    type: 'bar',
    chartName: 'force majeure',
  },
  AgreementTerm: {
    type: 'bar',
    chartName: 'agreement terms',
  },
  DisputeResolution: {
    type: 'pie',
    chartName: 'dispute resolution',
  },
  Indemnities: {
    type: 'pie',
    chartName: 'indemnities',
  },
  ExclusionConsequentialDamages: {
    type: 'pie',
    chartName: 'exclusion of consequential damages',
  },
};
